// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"da9e8d21","977":"83f3f7bd"}[chunkId] + ".chunk.js";
};